<div class="privacy-policy-container glass-card">
  <a (click)="returnHome()" class="return-button top-button"> &larr; Return </a>
  <header class="text-center mb-12">
    <h1 class="text-4xl md:text-5xl font-bold text-gray-900">מדיניות הפרטיות</h1>
  </header>

  <main class="bg-white p-8 md:p-12 rounded-2xl shadow-lg" dir="rtl">
    <p>
      ארטיסן סוניקס בע"מ, ח"פ 512212622 (להלן: "החברה") מכבדת את הפרטיות של המשתמשים בשירותיה של
      החברה, לרבות באמצעות אתרי האינטרנט שבבעלות החברה אותם היא מנהלת ומפעילה בכתובות
      https://artisansonics.com ו https://artisanmedical.co.il (להלן: "המשתמש" או "המשתמשים"
      ו-"האתר", בהתאמה).
    </p>
    <p>
      מדיניות פרטיות זו ומדיניות ה-Cookies (להלן יחד: "מדיניות הפרטיות") מסדירה את האופן שבו החברה
      עושה שימוש במידע אותו היא אוספת באתר.
    </p>
    <p>המידע המובא להלן מיועד לסייע למשתמש להבין את מדיניות הפרטיות של החברה.</p>
    <p>
      מדיניות הפרטיות כפי שתפורט להלן, תבהיר את המידע שהחברה אוספת אודות המשתמשים, לרבות באתר,
      המטרות שלשמן החברה אוספת את המידע, איזה שימוש אפשר שהחברה תעשה במידע, מי הם הצדדים השלישיים
      שהחברה תעביר להם מידע וכיצד החברה מטפלת ושומרת את המידע.
    </p>
    <p>המידע שהמשתמש מוסר לחברה תלוי בהסכמתו וברצונו של המשתמש ואינה נובעת מחובה חוקית.</p>
    <p>המידע ישמר במאגר המידע של החברה לצורך המטרות המפורטות במדיניות פרטיות זו.</p>
    <p>
      השימוש בשירותים המוצעים על ידי החברה, לרבות באתר, מעידים על הסכמת המשתמש למדיניות פרטיות זו
      וכי מידע יישמר וינוהל במאגר כאמור.
    </p>
    <p>
      השימוש במידע שבמאגר יעשה בהתאם להוראות מדיניות פרטיות זו או על פי הוראות כל דין, למטרות
      המפורטות להלן.
    </p>
    <p>מדיניות פרטיות זו כתובה בלשון זכר רק מטעמי נוחות ויש לראות בכתוב כמתייחס גם ללשון נקבה.</p>

    <ol class="main-policy-list">
      <li>
        <strong>מהו מידע</strong>
        <p>
          במדיניות זו, משמעות המונח "מידע" הוא כל מידע הנאסף על ידי החברה או נמסר לה על ידי המשתמש
          או מי מטעמו, במסגרת השימוש של המשתמש באתר או בשירותים הכלולים בו, שבאמצעותו ניתן לזהות את
          המשתמש ומידע המוגן על פי חוק הגנת הפרטיות, התשמ"א-1981 (להלן: "החוק").
        </p>
      </li>

      <li>
        <strong>המקורות שבאמצעותם החברה אוספת מידע אודות המשתמש</strong>
        <ol class="sub-policy-list">
          <li>
            מידע שהמשתמש מוסר לחברה בין היתר בקשר עם התעניינות בקשר עם רכישת שירותיה של החברה, לרבות
            באמצעות ווטסאפ, פייסבוק, LinkedIn, טלגרם, רשתות חברתיות וכיוב';
          </li>
          <li>מידע שהמשתמש מוסר לחברה בין היתר בקשר עם רכישת שירותיה של החברה;</li>
          <li>מידע שמתקבל אצל החברה בקשר עם השירותים שמעניקה החברה;</li>
          <li>כאשר המשתמש מבקש להצטרף לרשימת התפוצה של החברה (ניוזלטר);</li>
          <li>באמצעות שימוש באתר.</li>
        </ol>
      </li>

      <li>
        <strong>המידע אותו החברה אוספת אודות המשתמש</strong>
        <p>החברה תאסוף אודות המשתמשים את המידע שיפורט להלן (כולו או חלקו):</p>
        <ol class="sub-policy-list">
          <li>שם מלא;</li>
          <li>טלפון;</li>
          <li>טלפון נייד;</li>
          <li>דוא"ל;</li>
          <li>תאריך לידה;</li>
          <li>מספר ת"ז;</li>
          <li>כתובת;</li>
          <li>הקלטות של שיחות עם המשתמש, ככל שרלוונטי;</li>
          <li>העדפות צרכניות של המשתמש;</li>
          <li>
            כל מידע נוסף שהמשתמש מוסר ו/או מתקבל אצל החברה בקשר עם המשתמש ועם השימוש בשירותי החברה,
            לרבות שימוש באתר;
          </li>
          <li>
            בנוסף, במהלך השימוש באתר, החברה תאסוף מידע לא מזהה אודות המשתמשים, אשר אינו חושף את
            זהותם האישית של המשתמשים, כמפורט במדיניות הקוקיז בסעיף 10 להלן (להלן: "מידע לא מזהה").
          </li>
        </ol>
      </li>

      <li>
        <strong>מדוע החברה אוספת את המידע והשימוש שהחברה מבצעת במידע ("המטרות")?</strong>
        <p>החברה אוספת מידע אודות המשתמש לצורך המטרות הבאות - כולן או חלקן:</p>
        <ol class="sub-policy-list">
          <li>לשם ובקשר עם מתן השירותים המסופקים על ידי החברה או מי מטעמה;</li>
          <li>
            הפעלה וניהול של שירותי החברה, לרבות ניהול האתר לרבות שיווק, פרסום, קידום מכירות ועידוד
            רכישות;
          </li>
          <li>על מנת לאפשר את ביצוע הפעולות באמצעות האתר על ידי המשתמש;</li>
          <li>לשם פיתוח ותפעולו של האתר;</li>
          <li>לשם תחזוקה של האתר וניטור פעילות המשתמש בו;</li>
          <li>לשם שיפור איכות השירותים שמספקת החברה;</li>
          <li>לשם יצירת קשר עם המשתמש;</li>
          <li>לשם עריכת נתונים סטטיסטיים והעברת מידע לרבות סטטיסטי או אחר, לצדדים שלישיים;</li>
          <li>לשם ניתוח, ומחקר ועריכת סטטיסטיקות;</li>
          <li>לשם עריכת סקרים בקרב המשתמשים;</li>
          <li>
            לשם הצגה והתאמת מודעות שיוצגו בפני המשתמשים לרבות אך לא רק ברשת האינטרנט ועשויים להתאים
            להעדפותיהם;
          </li>
          <li>
            ניתוח פרופילים של המשתמשים בשירותי החברה, לרבות באתר, לשם שיווק מוצרים לרבות אך לא רק
            ברשת האינטרנט;
          </li>
          <li>
            לצורך משלוח באמצעים אלקטרוניים דברי פרסומת, מידע על מוצרים ושירותים, הטבות, מבצעים,
            הנחות ומידע שיווקי;
          </li>
          <li>לצרכי דיוור ישיר כהגדרתו בחוק;</li>
          <li>לצרכים פנימיים של החברה;</li>
          <li>
            לשם התגוננות מפני תביעות, דרישות וטענות נגד החברה ומי מטעמה וכן נגד צדדים שלישיים;
          </li>
          <li>לשם אכיפה של הוראות תנאי השימוש ומדיניות פרטיות זו;</li>
          <li>לשם עמידה בהוראות כל דין;</li>
          <li>
            כמו כן, החברה עושה שימוש במידע לא מזהה שנאסף באמצעים טכנולוגיים שונים, בין היתר, לצורך
            תפעול של האתר, על מנת להקל את השימוש באתר, לצורך בדיקות סטטיסטיות בקשר עם השימוש באתר
            ועוד, כמפורט בסעיף 10 למדיניות הפרטיות להלן.
          </li>
        </ol>
      </li>

      <li>
        <strong>העברה של המידע</strong>
        <p>החברה לא תעביר ולא תמסור מידע לצדדים שלישיים, אלא כמפורט במדיניות הפרטיות.</p>
        <p>
          העברת המידע לצדדים שלישיים תכלול מידע רלוונטי בלבד שאינו חורג מהמטרות שלשמן מועבר המידע
          ותתבצע באופן מידתי למטרה מוגדרת, מפורשת ולגיטימית.
        </p>
        <p>
          החברה רשאית להעביר את המידע או כל חלק ממנו לצדדים שלישיים בהתקיים אחד או יותר מהמקרים
          הבאים:
        </p>
        <ol class="sub-policy-list">
          <li>
            צדדים שלישיים אשר מעניקים לחברה שירותים שונים ובין היתר שירותי תמיכה במערכות האבטחה
            ומערכות טכגולוגיית מידע (IT), שירותי אחסון מידע, שירותי סליקה, שירותי בניית אתרים,
            שירותי עריכת סקרים ומחקרים, שירותי ניהול לקוחות, מערכות CRM, קבלני משנה מטעם החברה,
            חברות אשר מעניקות שירותי פרסום ושיווק, עורכי דין או יועצים מקצועיים חיצוניים אחרים וכן
            לשותפים עסקיים ולצדדים שלישיים נוספים אשר מעניקים לחברה שירותים בקשר עם פעילותה.
          </li>
          <li>
            אם תתקבל אצל החברה הוראה לרבות צו שיפוטי המורה לה למסור את פרטי המשתמש או מידע אודות
            המשתמש בהתאם להוראות כל דין.
          </li>
          <li>
            בכל מחלוקת, טענה, דרישה, תביעה או הליכים משפטיים כלשהם בין המשתמש או מי מטעמו לבין החברה
            או מי מטעמה.
          </li>
          <li>
            במקרה של העברה ו/או מכירה ו/או המחאה ו/או רכישה, של החברה ו/או נכסיה ו/או כל חלק מהם,
            בתמורה או שלא בתמורה, בין היתר במקרים אשר במסגרתם תועבר הבעלות באתר ו/או בתכניו, כולם או
            חלקם, לצדדים שלישיים, לרבות אך לא רק במקרה של מיזוג החברה ו/או פעילותה עם צדדים שלישיים,
            ולרבות מבלי לגרוע מכלליות האמור, במקרים של שינוי שליטה, מלא או חלקי, בחברה.
          </li>
          <li>
            אם תועלה טענה או יתעורר אצל החברה חשד כי משתמש ביצע מעשה ו/או מחדל אשר עשויים לפגוע
            בחברה, במי מטעמה, בצדדים שלישיים כלשהם לרבות משתמשים אחרים.
          </li>
          <li>
            אם תועלה טענה או יתעורר אצל החברה חשד כי משתמש עושה שימוש באתר לצורך ביצוע מעשה בלתי
            חוקי ו/או כדי לאפשר, להקל, לסייע ו/או לעודד את ביצועו של מעשה כזה.
          </li>
          <li>
            בכל מקרה שהחברה תסבור כי מסירת המידע נדרשת כדי למנוע נזק לחברה, למשתמש או לצד שלישי
            כלשהו.
          </li>
        </ol>
        <p>
          החברה רשאית להעביר את המידע לצדדים שלישיים, כאמור לעיל, גם מחוץ למדינת ישראל ובכלל זה
          לצדדים שלישיים אשר ממוקמים במדינות שרמת ההגנה של המידע שונה מהוראות הדין הישראלי ואשר
          עשויות להעניק הגנה פחותה מזו הניתנת על פי דיני הגנת הפרטיות בישראל.
        </p>
        <p>
          מבלי לגרוע מהוראות מדיניות זו, שימוש באתר מעיד על הסכמת המשתמש למדיניות הגנת פרטיות זו
          לרבות להעברת מידע, שמירתו ואחסונו אצל צדדים שלישיים אשר ממוקמים מחוץ למדינת ישראל.
        </p>
        <p>
          מבלי לגרוע מהוראות מדיניות פרטיות זו, החברה וכל מי מטעמה לא תישא בכל חבות, והיא פטורה מכל
          אחריות, בקשר עם כל נזק, הפסד או הוצאה, מכל מין וסוג שהם, בין אם ישירים ובין אם עקיפים ו/או
          נסיבתיים ו/או תוצאתיים, אשר נגרמו ו/או ייגרמו למשתמשים ו/או לצד שלישי, בכל הקשור והנוגע
          לספקי שירות לרבות בכל הקשור לאיסוף המידע על ידי ספקי שירות, השימוש בו, העברתו לצדדים
          שלישיים, שמירתו ואבטחתו על ידי ספקי שירות ועוד.
        </p>
      </li>

      <li>
        <strong>אבטחת מידע</strong>
        <p>החברה נוקטת באמצעים טכניים ופיזיים בעניין פרטיות ואבטחת מידע בהתאם לסטנדרטים מקובלים.</p>
        <p>
          כידוע, אחסונו והעברתו של מידע באמצעים אלקטרוניים, לרבות דרך רשת האינטרנט, לעולם לא יכול
          להיות בטוח לחלוטין ובכל עת שבה המשתמש מוסר מידע לחברה, בפרט באמצעות רשת האינטרנט, המשתמש
          עושה זאת בהסכמה מלאה ובכפוף לסכנות הכרוכות בהעברת המידע בדרך זו.
        </p>
        <p>החברה לא מתחייבת שהאתר יהיה חסין באופן מוחלט מפני גישה בלתי-מורשית למידע המאוחסן בו.</p>
        <p>
          בכל מקרה, אם יש למשתמש סיבה להאמין כי העברת המידע לחברה אינה בטוחה עוד, אנא עדכן אותנו
          באמצעי התקשרות שבסעיף 15 למדיניות הפרטיות.
        </p>
      </li>

      <li>
        <strong>הגבלת אחריות</strong>
        <p>
          החברה וכל מי מטעמה לא תישא בכל חבות, והיא פטורה מכל אחריות, בקשר עם כל נזק, הפסד או הוצאה,
          מכל מין וסוג שהם, בין אם ישירים ובין אם עקיפים ו/או נסיבתיים ו/או תוצאתיים, אשר נגרמו ו/או
          ייגרמו למשתמשים ו/או לצד שלישי, בכל הקשור והנוגע לאיסוף המידע, השימוש בו, העברתו לצדדים
          שלישיים, שמירתו ואבטחתו.
        </p>
      </li>

      <li>
        <strong>תקופת החזקה של המידע</strong>
        <p>
          החברה וכל מי מטעמה לא תישא בכל חבות, והיא פטורה מכל אחריות, בקשר עם כל נזק, הפסד או הוצאה,
          מכל מין וסוג שהם, בין אם ישירים ובין אם עקיפים ו/או נסיבתיים ו/או תוצאתיים, אשר נגרמו ו/או
          ייגרמו למשתמשים ו/או לצד שלישי, בכל הקשור והנוגע לאיסוף המידע, השימוש בו, העברתו לצדדים
          שלישיים, שמירתו ואבטחתו.
        </p>
      </li>

      <li>
        <strong>מידע על אנשים אחרים</strong>
        <p>
          אם המשתמש יספק מידע לחברה בקשר לאנשים אחרים, לרבות בני משפחתו וצדדים שלישיים נוספים, על
          המשתמש לעשות כן אך ורק לאחר:
        </p>
        <ol class="sub-policy-list">
          <li>(א) שהמשתמש עדכן את הצדדים השלישיים אודות תוכן מדיניות זו;</li>
          <li>
            (ב) המשתמש קיבל הסכמה הנדרשת לאיסוף, שימוש, חשיפה והעברה של מידע אודות הצד השלישי בהתאם
            למדיניות זו ובהתאם להוראות הדין, ככל שנדרש.
          </li>
        </ol>
      </li>

      <li>
        <strong>Cookies</strong>
        <p>
          האתר עושה שימוש ב-Cookies וטכנולוגיות אחרות לשם אחת או יותר מהמטרות המפורטות במדיניות
          פרטיות זו.
        </p>
        <p>
          למידע נוסף אודות אופן השימוש ב-Cookies ובטכנולוגיות באתר ניתן לעיין במדיניות ה-Cookies כאן
          (להלן: "מדיניות הקוקיז").
        </p>
      </li>

      <li>
        <strong>זכות עיון ותיקון המידע</strong>
        <p>
          הזכות לעיין ולתקן את המידע היא בהתאם להוראות החוק. אם המשתמש מעוניין לעיין או לתקן את
          המידע, ניתן לעשות זאת באמצעות פנייה לחברה בהתאם לפרטי התקשרות המופיעים בסעיף 15 למדיניות
          פרטיות זו להלן.
        </p>
      </li>

      <li>
        <strong>הדין החל וסמכות השיפוט</strong>
        <p>
          התנאים וההוראות המפורטים במדיניות הפרטיות, וכן כל שינוי או תיקון שלהם, כמו גם השימוש באתר,
          יוסדרו על פי חוקי מדינת ישראל ללא התייחסות לסעיפי ברירת הדין החלים בה.
        </p>
        <p>
          סמכות השיפוט בקשר עם כל מחלוקת ו/או תביעה אשר יתעוררו בקשר עם השימוש באתר ומדיניות פרטיות
          זו או הקשור אליו, מסורה באופן בלעדי לבתי המשפט בתל אביב-יפו.
        </p>
      </li>

      <li>
        <strong>שינויים ועדכונים</strong>
        <p>
          החברה רשאית, על פי שיקול דעתה הבלעדי, לשנות את מדיניות הפרטיות מעת לעת וזאת ללא צורך במתן
          הודעה או התראה על כך.
        </p>
        <p>
          מדיניות הפרטיות העדכנית שתפורסם באתר תחייב את המשתמש. המשך השימוש של המשתמש באתר לאחר
          עדכון מדיניות הפרטיות יהווה הסכמה של המשתמש למדיניות הפרטיות המעודכנת, לרבות לשינויים.
        </p>
      </li>

      <li>
        <strong>שונות</strong>
        <p>המשתמש אינו רשאי להסב את זכויותיו ו/או חובותיו על פי מדיניות פרטיות זו לאחר.</p>
        <p>החברה תוכל להעביר את זכויותיה ו/או התחייבויותיה לאחר.</p>
        <p>אין במדיניות פרטיות זו כדי לגרוע מכל זכות המוקנית לחברה ו/או למי מטעמה לפי כל דין.</p>
      </li>

      <li>
        <strong>גרסא מקוונת</strong>
        <!-- <p>להורדת גרסה מקוונת של מדיניות הפרטיות לחצו כאן</p> -->
        <ul class="list-none mt-4 space-y-3 poli-download" (click)="downloadPolicy()">
          <li>להורדת גרסה מקוונת של מדיניות הפרטיות לחצו כאן</li>
        </ul>
      </li>

      <li>
        <strong>יצירת קשר</strong>
        <p>
          ככל שלמשתמש ישנן שאלות נוספות או הערות בנוגע למדיניות הפרטיות, המשתמש מוזמן לפנות לחברה
          באמצעות:
        </p>
        <ul class="list-none mt-4 space-y-3">
          <li>
            <strong>דואר אלקטרוני:</strong>
            <a href="mailto:info@artisansonics.com">info&#64;artisansonics.com</a>
          </li>
        </ul>
      </li>
    </ol>
  </main>

  <footer class="text-center mt-12 text-sm text-gray-400">
    <p>&copy; 2025 Artisan Sonics. All Rights Reserved.</p>
  </footer>

  <a (click)="returnHome()" class="return-button bottom-button"> &larr; Return </a>
</div>
